import {
  USUARIOS_GET_TOOLS_BY_ROLE_BEGIN,
  USUARIOS_GET_TOOLS_BY_ROLE_SUCCESS,
  USUARIOS_GET_TOOLS_BY_ROLE_FAILURE,
  USUARIOS_GET_TOOLS_BY_ROLE_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getToolsByRole(id) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: USUARIOS_GET_TOOLS_BY_ROLE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/roles/" + id);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            let data = res.data.data;
            //let aux = [];
            data.Functions_Modules.forEach((function_module) => {
              function_module['function_id'] = function_module.Function.id;
              function_module['function_name'] = function_module.Function.Name;
              function_module['module_id'] = function_module.Module.id;
              function_module['module_name'] = function_module.Module.name;
            });
            // aux = _.map(data.Functions_Modules, 'function_id');
            // console.log("data: ", data)
            // console.log("aux")
            dispatch({
              type: USUARIOS_GET_TOOLS_BY_ROLE_SUCCESS,
              data: data,
            });
            resolve(data);
          } else {
            dispatch({
              type: USUARIOS_GET_TOOLS_BY_ROLE_FAILURE,
              data: { error: res.data.errorMessage },
            });
            reject(res.data.errorMessage);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USUARIOS_GET_TOOLS_BY_ROLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetToolsByRoleError() {
  return {
    type: USUARIOS_GET_TOOLS_BY_ROLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_GET_TOOLS_BY_ROLE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getToolsByRolePending: true,
        getToolsByRoleError: null,
      };

    case USUARIOS_GET_TOOLS_BY_ROLE_SUCCESS:
      // The request is success
      return {
        ...state,
        getToolsByRolePending: false,
        getToolsByRoleError: null,
      };

    case USUARIOS_GET_TOOLS_BY_ROLE_FAILURE:
      // The request is failed
      return {
        ...state,
        getToolsByRolePending: false,
        getToolsByRoleError: action.data.error,
      };

    case USUARIOS_GET_TOOLS_BY_ROLE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getToolsByRoleError: null,
      };

    default:
      return state;
  }
}
